<template>
  <div class="@container  flex ">
    <div class="flex-1  transition-all duration-300 ease-in-out overflow-y-auto">
      <div>
        <div class="flex  justify-between items-center">
          <div>
            <div v-if="data.machine">
              <h2 class="mr-2">{{ data.machine?.name }}</h2>
              <div class="badge-warning badge">
                {{ data.machine?.uuid }}
              </div>
            </div>
            <div v-else class="flex space-x-3">
              <div class="skeleton  h-8 w-32"></div>
              <div class="skeleton  h-8 w-56"></div>
            </div>
          </div>
          <div class="md:max-w-1/2 items-center gap-2">
            <div class="@sm/actions:grid
        @sm/actions:bg-red-400
        justify-between
        @sm/actions:grid-cols-2 gap-4 dark:text-base-200">
              <button class="btn m-2" @click.prevent="openInspectionFormModal">
                <div class="relative">
                  <PhCalendarBlank class="w-5 h-5"/>
                  <span class="absolute top-1" style="font-size: 8px; right: 5px; top: 6px">
                      {{ new Date().toLocaleDateString('en-US', {day: 'numeric'}) }}
                    </span>
                </div>
                Schedule Inspection
              </button>
              <SignalForm class="w-5 h-5"/>
              <button class="btn  m-2" @click.prevent="openDowntimeFormModal">
                <PhAlarm class="w-5 h-5"></PhAlarm>
                Downtime
              </button>
              <a :href="`/dashboard/organizations/${orgUUID}/machine_incidents/new?machine_id=${machineId}`"
                 class="btn btn-error  m-2 flex-grow dark:text-gray-200">
                <PhTrafficSignal class="w-5 h-5"></PhTrafficSignal>
                Report Issue
              </a>

            </div>


          </div>
        </div>
      </div>

      <!-- <Heatmap/> !-->
      <div class="@md:flex-grow">
        <MachineDashboard v-if="data.machine"
                          :data="data" :machine-id="route.params.machine_id"/>


      </div>
    </div>

<!--    <div v-show="activeWindow === 'ai_console'"
         class="w-1/3 mt-4 rounded-md ">
      <AiMachineConsole :machine-id="route.params.machine_id"
                        :organization-id="route.params.organization_uuid"></AiMachineConsole>
    </div>-->

    <div v-show="activeWindow === 'charts'"
         class="w-1/3 mt-4 rounded-md ">
      <Heatmap/>
      <MachineDashboard2/>
    </div>

    <div v-show="activeWindow === 'alerts'"
         class="w-1/3 mt-4 rounded-md ">
      <AnomaliesList :machine-id="route.params.machine_id"
                     :organization-id="route.params.organization_uuid"/>
    </div>

    <div v-show="activeWindow === 'readings'"
         class="w-1/3 mt-4 rounded-md ">
      <SensorsReadings :machine-id="route.params.machine_id"
                     :organization-id="route.params.organization_uuid"/>
    </div>

    <div v-show="activeWindow === 'devices'"
         class="w-1/3 mt-4 rounded-md ">
      <DevicesList :machine-id="route.params.machine_id"
                     :organization-id="route.params.organization_uuid"/>
    </div>

    <div class="w-14 mt-4 px-2 @md:flex flex-col gap-3">

      <div class="@md/actions:flex items-center p-2  justify-center rounded-md"
           :class="{'bg-gray-100 text-red-900': activeWindow === 'show'}">
        <button class="w-fit h-fit" @click.prevent="activeWindow = 'show'">
          <ph-info class="w-6 h-6 current-text"></ph-info>
        </button>
      </div>

<!--      <div class="flex items-center p-2  rounded-md"
           :class="{'bg-gray-100 text-red-900': activeWindow === 'ai_console'}">
        <button @click.prevent="activeWindow = 'ai_console'">
          <ph-robot class="w-6 h-6"></ph-robot>
        </button>

      </div>-->

      <div class="flex items-center p-2  rounded-md" :class="{'bg-gray-100 text-red-900': activeWindow === 'alerts'}">
        <button @click.prevent="activeWindow = 'alerts'">
          <ph-warning class="w-6 h-6"></ph-warning>
        </button>
      </div>

      <div class="flex items-center p-2  rounded-md" :class="{'bg-gray-100 text-red-900': activeWindow === 'charts'}">
        <button @click.prevent="activeWindow = 'charts'">
          <ph-chart-bar class="w-6 h-6"></ph-chart-bar>
        </button>
      </div>

      <div class="flex items-center p-2  rounded-md" :class="{'bg-gray-100 text-red-900': activeWindow === 'devices'}">
        <button @click.prevent="activeWindow = 'devices'">
          <ph-cpu class="w-6 h-6"></ph-cpu>
        </button>
      </div>
      <div class="flex items-center p-2  rounded-md" :class="{'bg-gray-100 text-red-900': activeWindow === 'readings'}">
        <button @click.prevent="activeWindow = 'readings'">
          <ph-database class="w-6 h-6"></ph-database>
        </button>
      </div>


    </div>
  </div>
</template>
<script setup>
import {onMounted, ref} from "vue";
import {generateData} from "~/lib/tools";

import MachineDashboard from './machine_dashboard.vue';
import MachineDashboard2 from './keep-ref-charts.vue';
import DevicesList from "./sensors/index.vue";
import AnomaliesList from "~/components/dashboard/machines/components/anomalies_list.vue";
import SensorsReadings from "~/components/dashboard/machines/sensors/sensors_readings.vue";

import {useRoute} from "vue-router";
import Heatmap from "./heatmap.vue";
import {fetchMachineInfo} from "~/lib/api/machines";
import {
  PhRobot,
  PhBug,
  PhSparkle,
  PhEye,
  PhInfo,
  PhWarning,
  PhChartBar,
  PhTrafficSignal,
  PhAlarm, PhCalendar, PhCalendarBlank, PhDatabase, PhGridNine, PhGridFour, PhCpu
} from "@phosphor-icons/vue";
import AiMachineConsole from "~/components/dashboard/ai/ai_console.vue";
import SignalForm from "~/components/dashboard/signals/signal_form.vue";

let route = useRoute();
const orgUUID = ref(route.params.organization_uuid);
const machineId = ref(route.params.machine_id);
let apexHeatmap = ref();
let activeWindow = ref("show");

let data = ref({machine: null});

const getInfo = () => {
  fetchMachineInfo(route.params.organization_uuid, route.params.machine_id).then(r => {
    data.value.machine = r.data.machine;
  })
}
onMounted(() => {
  getInfo();
});
</script>